module.exports = __webpack_public_path__ + "img/college_icon5.4281c7e.png";